import React from 'react';
import ReactDOM from 'react-dom';
import './main.css';
import Game from './components/Game';

ReactDOM.render(
  <Game />,
  document.getElementById('root'),
);
